import React from "react";
import utils from "../../modules/utils"
import FormRadioButton from "./components/FormRadioButton";

class Consolidamento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
    this.handler = this.handler.bind(this);
  }
  handler(event) {
    event.stopPropagation();
    var radio = event.currentTarget.getElementsByTagName("input")[0];
    radio.checked = true;
    this.props.handleCheck(radio.value)
  }
  render() {
    let consolidoVisible = this.props.prodotto == 1;
    const gState = utils.getState();
    if (gState.access_route == '/clink') {
      consolidoVisible = false;
    }
    return (
      <div id="consolidamento" className={(!consolidoVisible?'hidden':'')}>
        <h2>Hai dei finanziamenti con altre banche o finanziarie?</h2>
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell medium-6 medium-offset-3">
              <div className="grid-x grid-padding-x" id="radio-consolidamento">
                <div className={"cell medium-6"}>
                  <FormRadioButton
                    handler={this.handler}
                    validate="rb"
                    name="consolidamento"
                    label="Si"
                    value="1"
                  />
                </div>
                <div className={"cell medium-6"}>
                  <FormRadioButton
                    handler={this.handler}
                    validate="rb"
                    name="consolidamento"
                    label="No"
                    value="2"
                  />
                </div>
                <div className="error">{this.props.errors["consolidamento"]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    )
  }
}

export default Consolidamento;


// WEBPACK FOOTER //
// ./src/components/dati_personali/consolidamento.js